import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Toast, ListView, List, Picker, Popover} from "antd-mobile";
import { QuestionCircleOutline } from "antd-mobile-icons";
import Http from "../../config/axiosUtils";
import Empty from "../../components/common/Empty";
import { getStore } from "../../config/storage";

import "../../assets/scss/Custom/customList.scss";
import "../../assets/scss/Wallet/walletHome.scss";
import waitImg from "../../assets/images/wallet/wait_icon@2x.png";
import completeImg from "../../assets/images/wallet/complete_icon@2x.png";
import noImg from "../../assets/images/wallet/no_icon@2x.png";

class WalletHome extends Component {
  constructor() {
    super();
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    });
    this.state = {
      dataSource: dataSource, //列表初始化
      isLoading: true, //是否加载中
      initData: [], //总数据
      postData: {
        pageNumber: 1, //当前页数
        pageSize: 9, //每页个数
        type: 0, //类型
      },
      visible: false, // provide 是不是显示
      totalPage: 0, //总页数
      emptyData: false,
      balanceAmount: 0,
      waitAmount: 0,
      isHideMoney: false,
      withdrawSwitch: 1, //提现开关
      pickerData: [
        { label: "全部", value: "0" },
        { label: "待结算", value: "1" },
        { label: "提现", value: "2" },
        { label: "分佣", value: "3" },
        { label: "不结算", value: "4" },
        { label: "扣税", value: "5" },
        { label: "核销", value: "6" },
      ],
      picker: ["0"],
    };
  }

  //触底加载
  onEndReached = () => {
    if (!this.state.isLoading) {
      return;
    }
    const postData = this.state.postData;
    postData.pageNumber++;
    this.setState({
      isLoading: true,
      postData: postData,
    });
    setTimeout(() => {
      this.fetchData();
    }, 600);
  };

  componentDidMount() {
    this.setState({
      isHideMoney: getStore("eyeStatus"),
    });
    this.fetchData();
    this.fetchAmount();
  }

  fetchAmount = async () => {
    const path = "/spread/web/spread/wallet/info";
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        balanceAmount: res.data.balanceAmount,
        waitAmount: res.data.waitAmount,
        withdrawSwitch: res.data.withdrawSwitch,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  };

  fetchData = async () => {
    const path = "/spread/web/spread/wallet/deal/detail";
    const res = await Http.post(path, this.state.postData);
    if (res.code === 0) {
      if (!res.data.content.length) {
        this.setState({
          emptyData: true,
          initData: [],
        });
        return;
      }
      if (this.state.postData.pageNumber === 1 && this.state.dataSource.length !== 0) {
        this.setState({
          initData: [],
        });
      }
      const list = res.data.content;
      this.state.initData = this.state.initData.concat([list]);
      this.setState({
        initData: this.state.initData,
        dataSource: this.state.dataSource.cloneWithRows(this.state.initData),
        isLoading: true,
        postData: this.state.postData,
        emptyData: false,
      });
      if (this.state.postData.pageNumber === res.data.totalPages || res.data.totalPages === 0) {
        this.setState({
          isLoading: false,
        });
      }
    } else {
      Toast.fail(res.msg, 2);
    }
  };

  withdraw = () => {
    this.props.history.push("/withdraw");
  };

  onChangeType = (val) => {
    let postData = this.state.postData;
    postData.type = val[0];
    postData.pageNumber = 1;
    console.log(val);
    this.setState({
      isLoading: true,
      picker: val,
      postData: postData,
    });
    this.fetchData();
  };

  getListRightContentWithItem = (item) => {
    let rightItem = "";
    if (+item.type === 1) {
      rightItem = "可提现日期:" + item.settlementTime;
    } else if (+item.type === 4) {
      rightItem = "扣减日期:" + item.settlementTime;
    } else {
      rightItem = "可用余额:" + item.balanceAmount;
    }
    return rightItem;
  };

  getSpanStateWithItem = (item) => {
    if (+item.type === 1) {
      return <span className="waite_settlement">待结算</span>;
    } else if (+item.type === 3) {
      return <span className="complete-settlement">已结算</span>;
    } else if (+item.type === 4) {
      return <span className="no-settlement">不结算</span>;
    } else {
      return "";
    }
  };

  getSignWithItem = (item) => {
    if (+item.type === 1) {
      return waitImg;
    } else if (+item.type === 3) {
      return completeImg;
    } else if (+item.type === 4) {
      return noImg;
    } else {
      return "";
    }
  };

  // handleVisibleChange = (visible) => {
  //   console.log("visible: ", visible);
  //   this.setState({
  //     visible,
  //   });
  // };

  render() {
    const row = (rowData, sectionID, rowID) => {
      return (
        <ul>
          {rowData.map((item, index) => {
            return (
              <li key={index}>
                <div className="left">
                  <div>
                    {item.dealDesc}
                    {this.getSpanStateWithItem(item)}
                  </div>
                  <div>{item.dealAmount}</div>
                </div>
                <div className="right">
                  <div className="right-leftDate">{item.dealTime}</div>
                  <div className="right-rightDate">{this.getListRightContentWithItem(item)}</div>
                </div>
                {(+item.type === 1 || +item.type === 3 || +item.type === 4) && <img src={this.getSignWithItem(item)} alt="" />}
              </li>
            );
          })}
        </ul>
      );
    };


    return (
      <div>
        <Helmet>
          <title>钱包</title>
        </Helmet>

        <div className="walletHome">
          <div className="home-bg"></div>
          <div className="home-con" style={{ height: this.state.withdrawSwitch !== 0 ? "3.1rem" : "4.28rem" }}>
            <div className="home-top">
              <div className="left">
                <div className="home-title">
                  <span style={{marginRight:'10px'}}>可用余额(元)</span>
                  <Popover
                    overlayClassName="wallet-tips"
                    visible={this.state.visible}
                    // onVisibleChange={this.handleVisibleChange}
                    placement="top"
                    overlay={[
                      <span>可用余额满200元起提</span>,
                    ]}
                  >
                    <QuestionCircleOutline fontSize={16}  color='#7EC6EC' ></QuestionCircleOutline>
                  </Popover>

                </div>
                <div className="home-money">{this.state.isHideMoney ? "****" : this.state.balanceAmount}</div>
              </div>
              <div className="right">
                <div className="home-title">
                  <span style={{marginRight:'10px'}}>待结算金额(元)</span>
                </div>
                <div className="home-money">{this.state.isHideMoney ? "****" : this.state.waitAmount}</div>
              </div>
            </div>
            {this.state.withdrawSwitch === 0 && (
              <div className="home-btn" onClick={this.withdraw}>
                提现
              </div>
            )}
          </div>
          <div className="home-detail" style={{ marginTop: this.state.withdrawSwitch !== 0 ? "0.68rem" : "1.92rem" }}>
            <div className="detail-content">
              <div className="detail-title">交易明细</div>
              <div className="common-pic">
                <Picker data={this.state.pickerData} value={this.state.picker} cols={1} onChange={this.onChangeType}>
                  <List.Item arrow="down"></List.Item>
                </Picker>
              </div>
            </div>
            <div className="detail-con">
              {this.state.emptyData ? (
                <Empty tip="暂无数据.." />
              ) : (
                <ListView
                  ref={(el) => (this.lv = el)}
                  dataSource={this.state.dataSource}
                  renderFooter={() => <div style={{ textAlign: "center", padding: "0.2rem", backgroundColor: "#fff" }}>{this.state.isLoading ? "加载中..." : "已加载全部~"}</div>}
                  renderRow={row}
                  style={{ height: "6.95rem", overflow: "auto" }}
                  onEndReached={this.onEndReached}
                  onEndReachedThreshold={10}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WalletHome;
